module.exports = __webpack_public_path__ + "static/app_screen_4-275435b9e020220bfb13335e723c05f1.png";